<epay-page-content [pagetitle]="pagetitle">
  <!-- <epay-lib-common-changepassword
    [baseurl]="baseurl">
  </epay-lib-common-changepassword> -->

  <password-change [baseurl]="baseurl"></password-change>
</epay-page-content>
